export default __webpack_public_path__ + "static/media/man-laptop-v1.bdb026ef.svg";